<template>
  <v-form ref="form" @submit.prevent="submitForm">
    <v-container>
      <v-row v-for="field in form.fields" :key="field.model">
        <v-col cols="12">
          <component :is="getComponent(field)" v-bind="getFieldProps(field)" v-model="formData[field.model]" />
        </v-col>
      </v-row>
      <v-btn color="primary" @click="submitForm">Gönder</v-btn>
    </v-container>
  </v-form>
</template>

<script>

export default {
  props: {
    form: Object
  },
  data() {
    return {
      formData: {}
    };
  },
  created() {
    this.form.fields.forEach(field => {
      this.$set(this.formData, field.model, field.type === 'checkbox' ? false : '');
    });
  },
  methods: {
    getComponent(field) {
      switch (field.type) {
        case 'text':
        case 'email':
          return 'v-text-field';
        case 'select':
          return 'v-select';
        case 'checkbox':
          return 'v-checkbox';
        default:
          return 'v-text-field';
      }
    },
    getFieldProps(field) {
      const props = {
        label: field.label,
        required: field.required || false,
        items: field.type === 'select' ? field.options : undefined
      };
      return props;
    },
    submitForm() {
      if (this.$refs.form.validate()) {
        console.log('Gönderilen Veri:', this.formData);
        alert("Form başarıyla gönderildi!");
      }
    }
  }
};
</script>
